import { default as module } from './AbstractModule';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                item: 'onItemClick'
            }
        }

        this.$items = this.$('item')

        this.onItemEnterBind = this.onItemEnter.bind(this)
        for(let item of Array.from(this.$items)) {
            item.addEventListener('mouseenter', this.onItemEnterBind)
        }

        this.onLeaveBind = this.onLeave.bind(this)
        this.el.addEventListener('mouseleave', this.onLeaveBind)
    }

    init() {

    }

    onItemEnter(e) {
        this.call('showById', {
            id: this.getData('id', e.currentTarget),
            odd: Array.from(e.currentTarget.parentNode.children).indexOf(e.currentTarget) % 2 == 1
        }, 'Teammodal')
    }

    onLeave(e) {
        this.call('showById', {
            id: false
        }, 'Teammodal')
    }

    onItemClick(e) {
        this.call('open', null, 'Teammodal')
    }

    destroy() {
        for(let item of Array.from(this.$items)) {
            item.removeEventListener('mouseenter', this.onItemEnterBind)
            item.removeEventListener('mouseleave', this.onItemLeaveBind)
        }
    }
}
